import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType } from "vue";
import { Client } from "@/types/";
import { clientToSlug } from "@/tools/client";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientCard',
  props: {
    client: {
        type: Object as PropType<Client>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const setCurrent = () => {
    // this.$store.commit("clients/setCurrent", this.client);
    // localStorage.currentClient = this.client.id;
};

const isCurrent = computed(() => {
    return false;
    // return (
    //     this.$store.state.clients.current &&
    //     this.client.id === this.$store.state.clients.current.id
    // );
});

const slug = computed(() => clientToSlug(props.client, -1));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (setCurrent())),
    class: _normalizeClass([{ 'ClientCard--current': isCurrent.value }, "ClientCard"])
  }, _toDisplayString(slug.value), 3))
}
}

})